import React, { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
function getCountdownExpiry(): number {
  const cookieName = 'vvm_countdown_expiry';
  const match = document.cookie.match(new RegExp(`(?:^|; )${cookieName}=([^;]*)`));
  if (match) {
    return parseInt(match[1], 10);
  }
  const expiry = Date.now() + 24 * 60 * 60 * 1000;
  document.cookie = `${cookieName}=${expiry}; max-age=${24 * 60 * 60}; path=/`;
  return expiry;
}
function formatTime(ms: number): string {
  if (ms <= 0) return '00:00:00';
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
export function FlashBanner() {
  const [timeLeft, setTimeLeft] = useState('');
  const [expired, setExpired] = useState(false);
  useEffect(() => {
    const expiry = getCountdownExpiry();
    const tick = () => {
      const remaining = expiry - Date.now();
      if (remaining <= 0) {
        setTimeLeft('00:00:00');
        setExpired(true);
      } else {
        setTimeLeft(formatTime(remaining));
      }
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="fixed top-0 left-0 right-0 z-50 bg-yellow-400 overflow-hidden" data-id="element-47">
      <style data-id="element-48">
        {`
          @keyframes flashPulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.85; }
          }
          @keyframes fadeInOut {
            0%, 100% { opacity: 0.3; }
            50% { opacity: 1; }
          }
          .flash-pulse {
            animation: flashPulse 2s ease-in-out infinite;
          }
          .fade-in-out {
            animation: fadeInOut 2.5s ease-in-out infinite;
          }
        `}
      </style>
      <a href="#pricing" onClick={e => {
      e.preventDefault();
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }} className="block py-2 md:py-2.5 flash-pulse cursor-pointer" data-id="element-49">
        <div className="flex items-center justify-center gap-2 md:gap-3 px-4" data-id="element-50">
          <ZapIcon className="w-4 h-4 md:w-5 md:h-5 text-red-600 flex-shrink-0" data-id="element-51" />
          <span className="text-red-600 font-extrabold text-sm md:text-lg tracking-wide whitespace-nowrap" data-id="element-52">
            🔥 ESPECIAL DE HOY SOLAMENTE $17! 🔥
          </span>
          <ZapIcon className="w-4 h-4 md:w-5 md:h-5 text-red-600 flex-shrink-0" data-id="element-53" />
        </div>
        <div className="flex items-center justify-center mt-0.5 gap-2" data-id="element-54">
          <span className="text-black font-medium text-[10px] md:text-xs tracking-wide fade-in-out" data-id="element-55">
            {expired ? '⏰ ¡Tiempo Agotado! Precio vuelve a $27' : `Precio Vuelve A $27 En`}
          </span>
          {!expired && timeLeft && <span className="text-red-700 font-bold text-[11px] md:text-sm tabular-nums tracking-wider" data-id="element-56">
              ⏰ {timeLeft}
            </span>}
        </div>
      </a>
    </div>;
}